import { DesignData } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

const getDesignData = (state: RootState): DesignData | undefined => state.design.designData;

export default getDesignData;
